// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonStyle-btnPrimary-e2WUG {
  display: inline-block;
  border-color: var(--primary-bg) !important;
  background-color: var(--primary-bg) !important;
  color: var(--primary-btn-foreground) !important;
  padding: 7px 21px;
  font-weight: 500;
  font-size: 16px;
  border-radius: 4px;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  text-decoration: none !important;
  cursor: pointer;
  white-space: normal;
}

.commonStyle-btnPrimary-e2WUG:hover,
.commonStyle-btnPrimary-e2WUG:focus,
.commonStyle-btnPrimary-e2WUG:active,
.commonStyle-btnPrimary-e2WUG:active:hover,
.commonStyle-btnPrimary-e2WUG:active:focus {
  border-color: var(--primary-bg-hover) !important;
  background-color: var(--primary-bg-hover) !important;
  color: var(--primary-btn-foreground);
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.commonStyle-btnPrimaryBorder-wOKjy {
  border-color: var(--primary-bg);
  color: var(--primary-bg) !important;
  background-color: transparent !important;
  padding: 7px 21px;
  font-weight: 500;
  font-size: 16px;
  border-radius: 4px;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  text-decoration: none !important;
  border: 1px solid !important;
  cursor: pointer;
  white-space: normal;
}

.commonStyle-btnPrimaryBorder-wOKjy:hover,
.commonStyle-btnPrimaryBorder-wOKjy:focus,
.commonStyle-btnPrimaryBorder-wOKjy:active,
.commonStyle-btnPrimaryBorder-wOKjy:active:hover,
.commonStyle-btnPrimaryBorder-wOKjy:active:focus {
  border-color: var(--primary-bg);
  color: var(--primary-bg);
  background-color: transparent !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.commonStyle-btnPrimaryLink-eKClk {
  border: 1px solid var(--primary-bg) !important;
}

.commonStyle-btnLarge-AJx3B {
  padding: 9px 21px !important;
}

.commonStyle-btnSmall-QRXOw {
  padding: 5px 0px;
}

.commonStyle-btnBig-gFXNy {
  padding: 13px 21px !important;
}

.commonStyle-fullWidth-N46Io {
  width: 100%;
}

.commonStyle-noTextDecration-CUTff {
  text-decoration: none !important;
}

.commonStyle-textAlignRight-FMNex {
  text-align: right;
}

.commonStyle-textEnd-_kx3n {
  text-align: end;
}

.commonStyle-textAlignCenter-rv7rg {
  text-align: center;
}

.commonStyle-commonControlInput-e89n4 {
  padding: 10px 15px 10px 15px;
  height: 58px;
  border-radius: 4px;
  font-size: 16px;
  line-height: 24px;
  font-weight: normal;
  border: 1px solid var(--primary-border) !important;
  background-color: var(--primary-input-bg);
  color: var(--primary-foreground);
  -webkit-box-shadow: none;
          box-shadow: none;
}

.commonStyle-commonControlSelect-ZPanc {
  padding: 10px 35px 10px 15px;
  height: 58px;
  border-radius: 4px;
  font-size: 16px;
  line-height: 24px;
  font-weight: normal;
  border: 1px solid var(--primary-border) !important;
  background-color: var(--primary-input-bg);
  color: var(--primary-foreground);
  display: block;
  overflow: hidden;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  background-position: calc(100% - 5px) 50%;
  background-size: 30px 30px !important;
}

.commonStyle-commonControlTextArea-kFRTT {
  padding: 10px 15px 10px 15px;
  height: 92px !important;
  border: 1px solid var(--primary-border) !important;
  background-color: var(--primary-input-bg);
  color: var(--primary-foreground);
  border-radius: 4px;
  font-size: 16px;
  line-height: 24px;
  font-weight: normal;
  -webkit-box-shadow: none;
          box-shadow: none;
}

.commonStyle-noTextDecoration-QRDh3 {
  text-decoration: none !important;
}

.commonStyle-fontWeightNormal-czaqE {
  font-weight: normal;
}

.commonStyle-fontWeightMedium-rTxzX {
  font-weight: 500;
}

.commonStyle-fontWeightSemiBold-Wc1oR {
  font-weight: 600;
}

.commonStyle-fontWeightBold-MXveP {
  font-weight: 700;
}

/*-----------------------Profilephoto Upload Common Styles Start----------------------------- */

.commonStyle-picContainerMain-ihy5p {
  padding: 30px;
  -webkit-box-shadow: 0px 0px 15px 0px var(--primary-box-shadow);
          box-shadow: 0px 0px 15px 0px var(--primary-box-shadow);
  border-radius: 4px;
  position: relative;
}

.commonStyle-profilePic-_FGhS {
  border-radius: 100px;
}

.commonStyle-trashIcon-XxafO {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 22px;
  height: 22px;
  background: var(--common-black-primary-bg);
  padding-top: 3px;
  border: 0;
  border-radius: 2px;
  opacity: .9;
  color: var(--common-primary-white-foreground);
  cursor: pointer;
}

.commonStyle-trashIconNew-ALmLx {
  position: absolute;
  top: -14px;
  right: -14px;
}

.commonStyle-profileImageBg-ktlIu {
  padding-top: 60%;
  background-repeat: no-repeat;
  background-size: contain;
  border-radius: 4px;
  background-color: var(--tertiary-gray-bg);
  border: 1px dashed var(--secondary-border);
  background-position: center;
}

.commonStyle-cursorPointer-nPpUz {
  cursor: pointer;
}

.commonStyle-listingTitleText-jtKQY {
  margin: 0px 0px 18px 0px;
  font-size: 22px;
  font-weight: 600;
}

.commonStyle-trustBtnLarge-I_udR {
  padding: 9px 15px;
}

/*-----------------------Profilephoto Upload Common Styles End----------------------------- */

.commonStyle-noMargin-tqZen {
  margin: 0px;
}

.commonStyle-spaceTop1-uQbFl {
  margin-top: 6px;
}

.commonStyle-spaceTop2-cn_t9 {
  margin-top: 12px;
}

.commonStyle-spaceTop3-vfauG {
  margin-top: 18px;
}

.commonStyle-spaceTop5-InptK {
  margin-top: 30px;
}

.commonStyle-spaceTop4-yJ1Uz {
  margin-top: 24px;
}

.commonStyle-space1-slHA8 {
  margin-bottom: 6px;
}

.commonStyle-space2-vJ9ni {
  margin-bottom: 12px;
}

.commonStyle-space3-O8K8s {
  margin-bottom: 18px;
}

.commonStyle-space4-gCTw3 {
  margin-bottom: 24px;
}

.commonStyle-space5-Eg6uq {
  margin-bottom: 30px;
}

/*----------------------Password Show Icon Section ------------------------------*/

.commonStyle-pwdImage-_wIWK {
  position: absolute;
  right: 20px;
  top: 54px;
  cursor: pointer;
}

.commonStyle-pwdSection-BFOnU {
  position: relative;
}

.commonStyle-loginPwdSection-Vpv1C {
  top: 50px;
}

.commonStyle-commonLabelText-tLXT4 {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  margin: 0 0 6px;
  text-align: start;
  color: var(--primary-foreground);
}

.commonStyle-loginLabel-eJYEW {
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: 600;
}

.commonStyle-errorMessage-gLFq6 {
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

/*----------------------Phone-Input Field Start------------------------------*/

.commonStyle-editPhoneInputSection-L_Fza {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-preferred-size: 100%;
      flex-basis: 100%;
  -webkit-column-gap: 20px;
     -moz-column-gap: 20px;
          column-gap: 20px;
}

.commonStyle-phoneInputWidth-kArDj {
  width: 100%;
}

/*----------------------Phone-Input Field Start------------------------------*/

.commonStyle-noPadding-Po8nI {
  padding: 0px;
}

.commonStyle-flexEnd-o1ewm {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}

.commonStyle-flexCenter-DfLUe {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
}

.commonStyle-displayFlex-EGseX {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.commonStyle-alignCenter-O2Pp9 {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.commonStyle-flexWrap-oJTFd {
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.commonStyle-justifyContentCenter-vwbls {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.commonStyle-justifyContentFlexEnd-HmrVP {
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}

.commonStyle-justifyContentSpaceBetween-Wyht6 {
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.commonStyle-positionRelative-zD3GL {
  position: relative;
}

.commonStyle-alignFlexStart-V8bzW {
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}

.commonStyle-alignBaseline-L_IvI {
  -webkit-box-align: baseline;
      -ms-flex-align: baseline;
          align-items: baseline;
}

.commonStyle-flexShrinkNone-qd13z {
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.commonStyle-gap4-nBcbi {
  gap: 4px;
}

.commonStyle-gap8-vbI1d {
  gap: 8px;
}

.commonStyle-gap12-sYJb0 {
  gap: 12px;
}

.commonStyle-gap16-tt5TH {
  gap: 16px;
}

.commonStyle-gap24-HPpNl {
  gap: 24px;
}

.commonStyle-siteTextColor-ycZG9,
.commonStyle-siteTextColor-ycZG9:hover,
.commonStyle-siteTextColor-ycZG9:focus,
.commonStyle-siteTextColor-ycZG9:active {
  color: var(--primary-foreground);
}

.commonStyle-defaultImg-rSKpv {
  background-size: 30%;
}

.commonStyle-requiedBorder-eQnbv {
  height: 94px !important;
}

.commonStyle-loaderFlex-yUlDG {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-column-gap: 3px;
     -moz-column-gap: 3px;
          column-gap: 3px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.commonStyle-displayInlineBlock-XFZc6 {
  display: inline-block;
}

@media screen and (max-width:767px) {
  .commonStyle-editPhoneInputSection-L_Fza {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    row-gap: 20px;
  }
}

.commonStyle-loaderButtonFlex-I1E02 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 3px;
}

.commonStyle-btnFlexContainerEnd-Bn6fn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}

.commonStyle-displayGrid-dGTjx {
  display: grid;
}

.commonStyle-gridCols2-HEaxa {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

@media screen and (max-width: 991px) {
  .commonStyle-gridColsTab1-Sln1R {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .commonStyle-gapTab0-XLkRl {
    gap: 0px !important;
  }
}

@media screen and (max-width: 767px) {
  .commonStyle-gridColsMobile1-YYwiy {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./src/components/commonStyle.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,8CAA8C;EAC9C,+CAA+C;EAC/C,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mCAA2B;UAA3B,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;;EAKE,gDAAgD;EAChD,oDAAoD;EACpD,oCAAoC;EACpC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mCAA2B;UAA3B,2BAA2B;EAC3B,gCAAgC;EAChC,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;;EAKE,+BAA+B;EAC/B,wBAAwB;EACxB,wCAAwC;EACxC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kDAAkD;EAClD,yCAAyC;EACzC,gCAAgC;EAChC,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kDAAkD;EAClD,yCAAyC;EACzC,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,mCAA2B;UAA3B,2BAA2B;EAC3B,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,kDAAkD;EAClD,yCAAyC;EACzC,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+FAA+F;;AAC/F;EACE,aAAa;EACb,8DAAsD;UAAtD,sDAAsD;EACtD,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,yCAAyC;EACzC,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,6FAA6F;;AAC7F;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kFAAkF;;AAClF;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA,8EAA8E;;AAC9E;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,6BAAgB;MAAhB,gBAAgB;EAChB,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,8EAA8E;;AAC9E;EACE,YAAY;AACd;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;AACf;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,2BAAqB;MAArB,wBAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,oBAAc;MAAd,cAAc;AAChB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,uBAAe;KAAf,oBAAe;UAAf,eAAe;EACf,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,aAAa;EACf;AACF;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF","sourcesContent":[".btnPrimary {\n  display: inline-block;\n  border-color: var(--primary-bg) !important;\n  background-color: var(--primary-bg) !important;\n  color: var(--primary-btn-foreground) !important;\n  padding: 7px 21px;\n  font-weight: 500;\n  font-size: 16px;\n  border-radius: 4px;\n  box-shadow: none !important;\n  text-decoration: none !important;\n  cursor: pointer;\n  white-space: normal;\n}\n\n.btnPrimary:hover,\n.btnPrimary:focus,\n.btnPrimary:active,\n.btnPrimary:active:hover,\n.btnPrimary:active:focus {\n  border-color: var(--primary-bg-hover) !important;\n  background-color: var(--primary-bg-hover) !important;\n  color: var(--primary-btn-foreground);\n  box-shadow: none !important;\n}\n\n.btnPrimaryBorder {\n  border-color: var(--primary-bg);\n  color: var(--primary-bg) !important;\n  background-color: transparent !important;\n  padding: 7px 21px;\n  font-weight: 500;\n  font-size: 16px;\n  border-radius: 4px;\n  box-shadow: none !important;\n  text-decoration: none !important;\n  border: 1px solid !important;\n  cursor: pointer;\n  white-space: normal;\n}\n\n.btnPrimaryBorder:hover,\n.btnPrimaryBorder:focus,\n.btnPrimaryBorder:active,\n.btnPrimaryBorder:active:hover,\n.btnPrimaryBorder:active:focus {\n  border-color: var(--primary-bg);\n  color: var(--primary-bg);\n  background-color: transparent !important;\n  box-shadow: none !important;\n}\n\n.btnPrimaryLink {\n  border: 1px solid var(--primary-bg) !important;\n}\n\n.btnLarge {\n  padding: 9px 21px !important;\n}\n\n.btnSmall {\n  padding: 5px 0px;\n}\n\n.btnBig {\n  padding: 13px 21px !important;\n}\n\n.fullWidth {\n  width: 100%;\n}\n\n.noTextDecration {\n  text-decoration: none !important;\n}\n\n.textAlignRight {\n  text-align: right;\n}\n\n.textEnd {\n  text-align: end;\n}\n\n.textAlignCenter {\n  text-align: center;\n}\n\n.commonControlInput {\n  padding: 10px 15px 10px 15px;\n  height: 58px;\n  border-radius: 4px;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: normal;\n  border: 1px solid var(--primary-border) !important;\n  background-color: var(--primary-input-bg);\n  color: var(--primary-foreground);\n  box-shadow: none;\n}\n\n.commonControlSelect {\n  padding: 10px 35px 10px 15px;\n  height: 58px;\n  border-radius: 4px;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: normal;\n  border: 1px solid var(--primary-border) !important;\n  background-color: var(--primary-input-bg);\n  color: var(--primary-foreground);\n  display: block;\n  overflow: hidden;\n  appearance: none;\n  box-shadow: none !important;\n  background-position: calc(100% - 5px) 50%;\n  background-size: 30px 30px !important;\n}\n\n.commonControlTextArea {\n  padding: 10px 15px 10px 15px;\n  height: 92px !important;\n  border: 1px solid var(--primary-border) !important;\n  background-color: var(--primary-input-bg);\n  color: var(--primary-foreground);\n  border-radius: 4px;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: normal;\n  box-shadow: none;\n}\n\n.noTextDecoration {\n  text-decoration: none !important;\n}\n\n.fontWeightNormal {\n  font-weight: normal;\n}\n\n.fontWeightMedium {\n  font-weight: 500;\n}\n\n.fontWeightSemiBold {\n  font-weight: 600;\n}\n\n.fontWeightBold {\n  font-weight: 700;\n}\n\n/*-----------------------Profilephoto Upload Common Styles Start----------------------------- */\n.picContainerMain {\n  padding: 30px;\n  box-shadow: 0px 0px 15px 0px var(--primary-box-shadow);\n  border-radius: 4px;\n  position: relative;\n}\n\n.profilePic {\n  border-radius: 100px;\n}\n\n.trashIcon {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  width: 22px;\n  height: 22px;\n  background: var(--common-black-primary-bg);\n  padding-top: 3px;\n  border: 0;\n  border-radius: 2px;\n  opacity: .9;\n  color: var(--common-primary-white-foreground);\n  cursor: pointer;\n}\n\n.trashIconNew {\n  position: absolute;\n  top: -14px;\n  right: -14px;\n}\n\n.profileImageBg {\n  padding-top: 60%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  border-radius: 4px;\n  background-color: var(--tertiary-gray-bg);\n  border: 1px dashed var(--secondary-border);\n  background-position: center;\n}\n\n.cursorPointer {\n  cursor: pointer;\n}\n\n.listingTitleText {\n  margin: 0px 0px 18px 0px;\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.trustBtnLarge {\n  padding: 9px 15px;\n}\n\n/*-----------------------Profilephoto Upload Common Styles End----------------------------- */\n.noMargin {\n  margin: 0px;\n}\n\n.spaceTop1 {\n  margin-top: 6px;\n}\n\n.spaceTop2 {\n  margin-top: 12px;\n}\n\n.spaceTop3 {\n  margin-top: 18px;\n}\n\n.spaceTop5 {\n  margin-top: 30px;\n}\n\n.spaceTop4 {\n  margin-top: 24px;\n}\n\n.space1 {\n  margin-bottom: 6px;\n}\n\n.space2 {\n  margin-bottom: 12px;\n}\n\n.space3 {\n  margin-bottom: 18px;\n}\n\n.space4 {\n  margin-bottom: 24px;\n}\n\n.space5 {\n  margin-bottom: 30px;\n}\n\n/*----------------------Password Show Icon Section ------------------------------*/\n.pwdImage {\n  position: absolute;\n  right: 20px;\n  top: 54px;\n  cursor: pointer;\n}\n\n.pwdSection {\n  position: relative;\n}\n\n.loginPwdSection {\n  top: 50px;\n}\n\n.commonLabelText {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n  margin: 0 0 6px;\n  text-align: start;\n  color: var(--primary-foreground);\n}\n\n.loginLabel {\n  font-size: 16px;\n  margin-bottom: 10px;\n  font-weight: 600;\n}\n\n.errorMessage {\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}\n\n/*----------------------Phone-Input Field Start------------------------------*/\n.editPhoneInputSection {\n  display: flex;\n  flex-basis: 100%;\n  column-gap: 20px;\n}\n\n.phoneInputWidth {\n  width: 100%;\n}\n\n/*----------------------Phone-Input Field Start------------------------------*/\n.noPadding {\n  padding: 0px;\n}\n\n.flexEnd {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.flexCenter {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.displayFlex {\n  display: flex;\n}\n\n.alignCenter {\n  align-items: center;\n}\n\n.flexWrap {\n  flex-wrap: wrap;\n}\n\n.justifyContentCenter {\n  justify-content: center;\n}\n\n.justifyContentFlexEnd {\n  justify-content: flex-end;\n}\n\n.justifyContentSpaceBetween {\n  justify-content: space-between;\n}\n\n.positionRelative {\n  position: relative;\n}\n\n.alignFlexStart {\n  align-items: flex-start;\n}\n\n.alignBaseline {\n  align-items: baseline;\n}\n\n.flexShrinkNone {\n  flex-shrink: 0;\n}\n\n.gap4 {\n  gap: 4px;\n}\n\n.gap8 {\n  gap: 8px;\n}\n\n.gap12 {\n  gap: 12px;\n}\n\n.gap16 {\n  gap: 16px;\n}\n\n.gap24 {\n  gap: 24px;\n}\n\n.siteTextColor,\n.siteTextColor:hover,\n.siteTextColor:focus,\n.siteTextColor:active {\n  color: var(--primary-foreground);\n}\n\n.defaultImg {\n  background-size: 30%;\n}\n\n.requiedBorder {\n  height: 94px !important;\n}\n\n.loaderFlex {\n  display: flex;\n  column-gap: 3px;\n  align-items: center;\n}\n\n.displayInlineBlock {\n  display: inline-block;\n}\n\n@media screen and (max-width:767px) {\n  .editPhoneInputSection {\n    flex-direction: column;\n    row-gap: 20px;\n  }\n}\n\n.loaderButtonFlex {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n}\n\n.btnFlexContainerEnd {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.displayGrid {\n  display: grid;\n}\n\n.gridCols2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n@media screen and (max-width: 991px) {\n  .gridColsTab1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .gapTab0 {\n    gap: 0px !important;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .gridColsMobile1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnPrimary": `commonStyle-btnPrimary-e2WUG`,
	"btnPrimaryBorder": `commonStyle-btnPrimaryBorder-wOKjy`,
	"btnPrimaryLink": `commonStyle-btnPrimaryLink-eKClk`,
	"btnLarge": `commonStyle-btnLarge-AJx3B`,
	"btnSmall": `commonStyle-btnSmall-QRXOw`,
	"btnBig": `commonStyle-btnBig-gFXNy`,
	"fullWidth": `commonStyle-fullWidth-N46Io`,
	"noTextDecration": `commonStyle-noTextDecration-CUTff`,
	"textAlignRight": `commonStyle-textAlignRight-FMNex`,
	"textEnd": `commonStyle-textEnd-_kx3n`,
	"textAlignCenter": `commonStyle-textAlignCenter-rv7rg`,
	"commonControlInput": `commonStyle-commonControlInput-e89n4`,
	"commonControlSelect": `commonStyle-commonControlSelect-ZPanc`,
	"commonControlTextArea": `commonStyle-commonControlTextArea-kFRTT`,
	"noTextDecoration": `commonStyle-noTextDecoration-QRDh3`,
	"fontWeightNormal": `commonStyle-fontWeightNormal-czaqE`,
	"fontWeightMedium": `commonStyle-fontWeightMedium-rTxzX`,
	"fontWeightSemiBold": `commonStyle-fontWeightSemiBold-Wc1oR`,
	"fontWeightBold": `commonStyle-fontWeightBold-MXveP`,
	"picContainerMain": `commonStyle-picContainerMain-ihy5p`,
	"profilePic": `commonStyle-profilePic-_FGhS`,
	"trashIcon": `commonStyle-trashIcon-XxafO`,
	"trashIconNew": `commonStyle-trashIconNew-ALmLx`,
	"profileImageBg": `commonStyle-profileImageBg-ktlIu`,
	"cursorPointer": `commonStyle-cursorPointer-nPpUz`,
	"listingTitleText": `commonStyle-listingTitleText-jtKQY`,
	"trustBtnLarge": `commonStyle-trustBtnLarge-I_udR`,
	"noMargin": `commonStyle-noMargin-tqZen`,
	"spaceTop1": `commonStyle-spaceTop1-uQbFl`,
	"spaceTop2": `commonStyle-spaceTop2-cn_t9`,
	"spaceTop3": `commonStyle-spaceTop3-vfauG`,
	"spaceTop5": `commonStyle-spaceTop5-InptK`,
	"spaceTop4": `commonStyle-spaceTop4-yJ1Uz`,
	"space1": `commonStyle-space1-slHA8`,
	"space2": `commonStyle-space2-vJ9ni`,
	"space3": `commonStyle-space3-O8K8s`,
	"space4": `commonStyle-space4-gCTw3`,
	"space5": `commonStyle-space5-Eg6uq`,
	"pwdImage": `commonStyle-pwdImage-_wIWK`,
	"pwdSection": `commonStyle-pwdSection-BFOnU`,
	"loginPwdSection": `commonStyle-loginPwdSection-Vpv1C`,
	"commonLabelText": `commonStyle-commonLabelText-tLXT4`,
	"loginLabel": `commonStyle-loginLabel-eJYEW`,
	"errorMessage": `commonStyle-errorMessage-gLFq6`,
	"editPhoneInputSection": `commonStyle-editPhoneInputSection-L_Fza`,
	"phoneInputWidth": `commonStyle-phoneInputWidth-kArDj`,
	"noPadding": `commonStyle-noPadding-Po8nI`,
	"flexEnd": `commonStyle-flexEnd-o1ewm`,
	"flexCenter": `commonStyle-flexCenter-DfLUe`,
	"displayFlex": `commonStyle-displayFlex-EGseX`,
	"alignCenter": `commonStyle-alignCenter-O2Pp9`,
	"flexWrap": `commonStyle-flexWrap-oJTFd`,
	"justifyContentCenter": `commonStyle-justifyContentCenter-vwbls`,
	"justifyContentFlexEnd": `commonStyle-justifyContentFlexEnd-HmrVP`,
	"justifyContentSpaceBetween": `commonStyle-justifyContentSpaceBetween-Wyht6`,
	"positionRelative": `commonStyle-positionRelative-zD3GL`,
	"alignFlexStart": `commonStyle-alignFlexStart-V8bzW`,
	"alignBaseline": `commonStyle-alignBaseline-L_IvI`,
	"flexShrinkNone": `commonStyle-flexShrinkNone-qd13z`,
	"gap4": `commonStyle-gap4-nBcbi`,
	"gap8": `commonStyle-gap8-vbI1d`,
	"gap12": `commonStyle-gap12-sYJb0`,
	"gap16": `commonStyle-gap16-tt5TH`,
	"gap24": `commonStyle-gap24-HPpNl`,
	"siteTextColor": `commonStyle-siteTextColor-ycZG9`,
	"defaultImg": `commonStyle-defaultImg-rSKpv`,
	"requiedBorder": `commonStyle-requiedBorder-eQnbv`,
	"loaderFlex": `commonStyle-loaderFlex-yUlDG`,
	"displayInlineBlock": `commonStyle-displayInlineBlock-XFZc6`,
	"loaderButtonFlex": `commonStyle-loaderButtonFlex-I1E02`,
	"btnFlexContainerEnd": `commonStyle-btnFlexContainerEnd-Bn6fn`,
	"displayGrid": `commonStyle-displayGrid-dGTjx`,
	"gridCols2": `commonStyle-gridCols2-HEaxa`,
	"gridColsTab1": `commonStyle-gridColsTab1-Sln1R`,
	"gapTab0": `commonStyle-gapTab0-XLkRl`,
	"gridColsMobile1": `commonStyle-gridColsMobile1-YYwiy`
};
module.exports = ___CSS_LOADER_EXPORT___;
